var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 15.5885V9.57992H12.2459L12.5472 7.22736H10.2188V5.72887C10.2188 5.05 10.408 4.58521 11.3823 4.58521H12.6168V2.48776C12.0161 2.42339 11.4124 2.3923 10.8082 2.39466C9.0165 2.39466 7.78633 3.48846 7.78633 5.49647V7.22296H5.77246V9.57552H7.79073V15.5885H10.2188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ad186772decc03d4d25f25a3c6da6791.svg";
export { ForwardRef as ReactComponent };